import _ from 'lodash';

export const stringMixin = {
  methods: {
    capitalize(str) {
      if (_.isNumber(str)) {
        return str;
      }

      return _.capitalize(str);
    }
  }
};
